import type { AdminHook } from './useAdmin';

type AdminTabsProps = Pick<AdminHook, 'setBucket' | 'tabs'>;

export function AdminTabs({ setBucket, tabs }: Readonly<AdminTabsProps>) {
	return (
		<div className="admin-dashboard__tabs" role="tablist">
			{tabs.map(tab => (
				<button
					className={`admin-tab ${tab.isActive ? 'admin-tab--active' : ''}`}
					key={tab.key}
					onClick={() => setBucket(tab.key)}
					type="button"
				>
					<span>{tab.label}</span>
					<span className="admin-tab__count">{tab.count}</span>
				</button>
			))}
		</div>
	);
}
